import { put, takeLatest, select, all } from 'redux-saga/effects';
import { getSelectedRefundFamilyIds } from '../passengers/selectors';
import { getSelectedReason } from '../selectedReason/selectors';
import { SET_SELECTED_REASON } from '../selectedReason/actions';
import { setDocuments } from './actions';
import { ReasonCategory } from '../types';
function* setInitialDocuments() {
    var _a;
    const [selectedPassengersIds, selectedReason] = yield all([
        select(getSelectedRefundFamilyIds),
        select(getSelectedReason)
    ]);
    if (!selectedReason ||
        !((_a = selectedReason.docs) === null || _a === void 0 ? void 0 : _a.length) ||
        !selectedPassengersIds.length ||
        (selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.category) === ReasonCategory.Voluntary) {
        yield put(setDocuments({}));
        return;
    }
    const documents = {};
    /** Сетаем пустые документы для каждого пассажира при выборе причины возврата */
    selectedPassengersIds.forEach(passengerId => {
        documents[passengerId] = [];
    });
    yield put(setDocuments(documents));
    return;
}
/** После выбора причины возврата, инициализируем документы */
export function* documentsSagas() {
    yield takeLatest(SET_SELECTED_REASON, setInitialDocuments);
}
